import { render, staticRenderFns } from "./work_card.vue?vue&type=template&id=2b787df5&scoped=true"
import script from "./work_card.vue?vue&type=script&lang=js"
export * from "./work_card.vue?vue&type=script&lang=js"
import style0 from "./work_card.vue?vue&type=style&index=0&id=2b787df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b787df5",
  null
  
)

export default component.exports